import { gql } from '@apollo/client';
import {
  Article,
  ArticleFilterInput,
  ArticleOrderingInput,
} from '../../../__generated__/queries-web';

export const GET_ARTICLE_PLANNING = gql`
  query GetArticlePlanning(
    $where: ArticleFilterInput
    $orderBy: [ArticleOrderingInput!]
  ) {
    articles(first: 50, where: $where, orderBy: $orderBy) {
      id
      title
      publishedAt
      status
    }
  }
`;

export interface GetArticlePlanningQuery {
  articles: Pick<Article, 'id' | 'title' | 'publishedAt' | 'status'>[];
}

export interface GetArticlePlanningQueryVariables {
  where?: ArticleFilterInput;
  orderBy?: ArticleOrderingInput[];
}
